import { Collapse } from "antd";
import React, { useState } from "react";
import vectorIcon from "../../../../../assets/disabilityIcons/icon-park-solid_right-c.svg";
import AddIcon from "../../../../../assets/disabilityIcons/Frame 427319007.svg";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import "./style.css";
import DropdownWithButton from "../Dropdown/DropdownWithButton";

const DropDownTitles = [
  "Insurance Agents",
  "Out-of-state Contact Person",
  "Pediatrician Contact",
  "Primary Doctor Contact Information",
  "Household Members",
  "Employee Contact List",
  "Family Contacts (Local)",
  "Family Contacts (Distant)",
  "Insurance Agents",
  "Agent Contact Information",
  "Out-of-State Contact Person",
  "Personal Information",
  "Children",
  "Current Income",
  "Spouse's Income",
  "Insurance Policies",
  "Joint Obligations",
  "Individual Obligations",
  "Pre Marriage Debt",
  "Attorney",
  "Mediator",
  "Financial Advisor",
  "Accountant",
  "Real Estate Agent",
  "Insurance Agent",
  "Therapist",
  "Child Specialist",

  
];
export default function CollapseableTable({
  title,
  key,
  children,
  onClick,
  setModuleName,
  show,
  options,
  formData,
  setFormData,
  createAttributes,
  handleFormDataUpdate,
}) {
  const { Panel } = Collapse;

  console.log("All dropdown options from DB:", options);

  return (
    <div className="collapseable-container">
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
           
          >
            <img
              src={vectorIcon}
              alt="vector-icon"
              width="20px"
              height="20px"
              style={{
                transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease-in-out",
              }}
            />
          </div>
        )}
      >
        <Panel
          header={<span className="panel-custom-header">{title}</span>}
          key={key}
        >
          <div className="panel-main-container">
            <div className="panel-content-container">
              {DropDownTitles.includes(title) && (
                <DropdownWithButton
                  options={options}
                  formData={formData}
                  title={title}
                  setFormData={setFormData}
                  handleFormDataUpdate={handleFormDataUpdate}
                  setModuleName={setModuleName}
                  createAttributes={createAttributes}
                />
              )}
              {/* Header Section */}
              <div className="header-container">
                <div className="header-title-container" onClick={setFormData}>
                  <h3 className="header-title">{title}</h3>
                </div>
                {!show && (
                  <div
                    className="add-condition-button-container"
                    onClick={() => onClick(title)}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={AddIcon} alt="add icon" />
                  </div>
                )}
              </div>
              {children}
            </div>
          </div>
        </Panel>
      </Collapse>
    </div>
  );
}
